
import React, { useEffect, useState } from "react";
import userModule from "../Apis/userModule";
import { useForm } from "react-hook-form";
import { notifySuccess, notifyError } from "../utils/toast"; 
import { handleGetAllUsers, handleGetRoleBasedUsers, handleUpdateUserById } from "../services/userService";
import { userID } from "../utils/storage";
import { handleCreateEvent, handleGetAllEvents, handleUpdateEvent } from "../services/routes/eventRoute";
import EventModel from "../Apis/EventModel";
import { Timestamp } from "firebase/firestore";
import moment from "moment";
const useEvents = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();

  const [user, setUser] = useState(null);
  const [userCache, setUserCache] = useState(new Map());
  const [prevIdStack, setPrevIdStack] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);
  const [userForm, setUserForm] = useState({});
  const [limit, setLimit] = useState(10);
  const [nextId, setNextId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [activeStatus, setActiveStatus] = useState(false);
  const [userResignCount, setUserResignCount] = useState(0);
  const [pendingDeactivation, setPendingDeactivation] = useState(null); 
  const [loading2 , setLoading2] = useState(false);
  const [hasMore , setHasMore] = useState(false);
  const [selectedAssistant , setSelectedAssistant] = useState(null);

  const [isListModelOpen, setIsListModelOpen] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [presonList, setPresonList] = useState([]);
  const [selectedId, setSelectedId] = useState();
  const [loader , setLoader] = useState(false);

  const getUserData = async (
    searchKey,
    cursor,
    limit,
    isBack = false,
    pageNumber = currentPage
  ) => {
    setLoading(true);

    if (isBack && userCache.has(pageNumber)) {
      setUser(userCache.get(pageNumber));
      setLoading(false);
      return;
    }

    const options = {
      limitCount: limit,
      searchKey: searchKey,
      startAfterDoc: cursor,
    };
    console.log("Payload ", options);

    try {
      const response = await handleGetAllEvents(options);
      const users = response?.events || [];
      console.log("User Response ", response);

      const receivedFullPage = users.length === limit;
      const hasMoreData = receivedFullPage && !!response.lastDoc;
      setHasMore(hasMoreData)

      console.log("hasMoreData" , hasMoreData)


      setUser(users);
      setNextId(response?.lastDoc);
      setActiveStatus(response.users?.status);

      setUserCache((prev) => new Map(prev).set(pageNumber, users));
    } catch (error) {
      console.log(error);
      setUser([]);
    } finally {
      setLoading(false);
    }
  };

    const handlePresonList = async () => {
      try {
        const response = await handleGetRoleBasedUsers("");
        setPresonList(response);
      } catch (error) {
        console.error("Error fetching person list:", error);
        notifyError("Failed to fetch person list. Please try again.");
      }
    };
  
    
  
    useEffect(() => {
      handlePresonList();
    }, []);

  const handlePageChange = (cursor, direction) => {
    if (direction === "next") {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);

      if (userCache.has(nextPage)) {
        setUser(userCache.get(nextPage));
      } else {
        getUserData(searchKey, nextId, limit, false, nextPage);
      }
    } else if (direction === "previous" && currentPage > 1) {
      const prevPage = currentPage - 1;
      const newStack = [...prevIdStack];
      const prevCursor = newStack.pop();
      setPrevIdStack(newStack);
      setCurrentPage(prevPage);

      if (userCache.has(prevPage)) {
        setUser(userCache.get(prevPage));
        const nextPageData = userCache.get(prevPage + 0 );
        console.log(nextPageData)
        setHasMore(!!nextPageData && nextPageData.length >= limit);
      } else {
        getUserData(searchKey, prevCursor, limit, true, prevPage);
      }
    }
  };

  const handlePageSize = (value) => {
    setLimit(value);
    setCurrentPage(1);
    setPrevIdStack([]);
    setUserCache(new Map());
    setNextId("");
    getUserData(searchKey, "", value, false, 1);
  };

  const handleStatus = async (userId) => {
    try {
      const body = {
        userId: userId,
      };
      setVisible(false); 
      setLoading2(true)
      const response = await userModule.checkUserDeative(body);
      console.log(response);
      if (response.status === 200) {
        setUserResignCount(response.data?.count || 0);
        setPendingDeactivation({ userId });
        setOpenStatus(true); 
       
      } 
    } catch (error) {
      console.log(error);
      notifyError("Error validating user for deactivation");
    }finally{
      setLoading2(false)
    }
  };

  const handleDeactiveUser = async () => {
    const { userId } = pendingDeactivation;
    setOpenStatus(false);
    setVisible(false);
  setLoading(true)

    try {
      const response = await handleUpdateUserById(userId, {
        status: false,
        modifiedBy: userID,
      });
      console.log(response)
      notifySuccess("Successfully Deactivated User");
      setPendingDeactivation(null); 
      setPrevIdStack([]);
      setUserCache(new Map());
      getUserData(searchKey, "", limit, false, 1);
    } catch (error) {
      console.log(error);
      notifyError("Failed to deactivate user");
    }finally{
      setLoading(false)
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    setPrevIdStack([]);
    setUserCache(new Map());
    getUserData(searchKey, "", limit, false, 1);
  };

  const handleUserManage = async (data) => {

    // if(data)
    // {
    //   console.log(data)
    //   return
    // }
    setLoading(true);
    try {
      if (data?.id) {

        const body ={
          eventId : data.id ,
          name: data.name,
          date : data.date,
          time : data.time,
          durationHours : data.durationHours,
          durationMinutes : data.durationMinutes,
          description : data.description,
          setReminder : data.setReminder,
          venue : data.venue,
          modifiedById: userID,
        }
        console.log(body);
    
        const response = await handleUpdateEvent(body);
        console.log(response)
        reset();
        setExiting(false)
        notifySuccess(response);
      } else {
  //       const dateString = data.date;           // e.g. "2025-08-12"
  //       const timeString = data.time;           // e.g. "15:51"
  //       const durationHours = data.durationHours || 0;
  //       const durationMinutes = data.durationMinutes || 0;
        
  //       // 1. Create start datetime with moment
  //       const startMoment = moment(`${dateString} ${timeString}`, "YYYY-MM-DD HH:mm");
        
  //       // 2. Create Firebase Timestamp for start
  //       const startTimestamp = Timestamp.fromDate(startMoment.toDate());
        
  //       // 3. Calculate end datetime by adding duration
  //       const endMoment = startMoment.clone().add(durationHours, "hours").add(durationMinutes, "minutes");
        
  //       // 4. Create Firebase Timestamp for end
  //       const endTimestamp = Timestamp.fromDate(endMoment.toDate());
        
  //       // 5. Build request body
  //       const body = {
  //         startTimestamp: {
  //   _seconds: startTimestamp.seconds,
  //   _nanoseconds: startTimestamp.nanoseconds
  // },
  // endTimestamp: {
  //   _seconds: endTimestamp.seconds,
  //   _nanoseconds: endTimestamp.nanoseconds
  // }

  //       };


  //       console.log(body)
       
        // const checkConflictResponse = await EventModel.CheckConflictEvent(body)
        // console.log("checkConflictResponse.data?.conflict" , checkConflictResponse.data.conflict)

        // if(checkConflictResponse.data.conflict)
        // {
        //   notifyError(checkConflictResponse.data.message)
        //   return
        // }else{

        if(!selectedAssistant )
        {
          notifyError("Please select an assistant");
          return;
        }
          const response = await handleCreateEvent({
            name: data.name,
            date : data.date,
            time : data.time,
            durationHours : data.durationHours,
            durationMinutes : data.durationMinutes,
            description : data.description,
            setReminder : data.setReminder,
            venue : data.venue,
            assigneeId : selectedAssistant.value,
            createdById: userID,
          });
  
  
        
            notifySuccess(response?.message);
            reset();
            setSelectedAssistant(null)
        // }

       
       
      }
      setVisible(false);
      setPrevIdStack([]);
      setUserCache(new Map());
      getUserData(searchKey, "", limit, false, 1);
    } catch (error) {
      console.log(error);
      if(error.response?.status === 409)
      {
        notifyError(error?.response?.data);
      }else{
        if (error.code === "DUPLICATE_PHONE") {
          notifyError(error.message);
        } else {
          notifyError("An unexpected error occurred.");
        }
      }
      
    } finally {
      setLoading(false);
    }
  };

  const handleReassign = async (meetingId, id , exitingId) => {
 


     const body= {
      prevAssineeId: exitingId,
          newAssigneeId : id,
          changeById: userID,
          meetingId :meetingId
        }

        
        setLoader(true)
    try {
      const response = await userModule.ResignMeeting(body)
      if(response.status ===  200)
      {
        notifySuccess(response?.data);
        setIsListModelOpen(false);
        setUserCache(new Map());
        getUserData(searchKey, "", limit, false, 1);
      }
      
    } catch (error) {
      console.error("Reassign error:", error);
      notifyError("Failed to reassign meeting. Please try again.");
    }finally{
      setLoader(false)
    }
  };

  const handleExitingData = async (data) => {

 
  
    setVisible(true);
    setExiting(true);
   
    setSelectedAssistant({
      value : data?.assignee.id,
      label : data?.assignee.name
    })
    reset({ ...data, id: data.id });
  };

  const handleToggle = () => {
    reset({ name: "" });
    setVisible(!visible);
  };

  useEffect(() => {
    getUserData(searchKey, "", limit, false, 1);
  }, [limit]);

  return {
    reset,
    user,
    loading,
    userForm,
    setUserForm,
    setUser,
    setLoading,
    register,
    handleSubmit,
    errors,
    watch,
    handleUserManage,
    handleExitingData,
    visible,
    setVisible,
    exiting,
    setExiting,
    handleToggle,
    handleSearchSubmit,
    setSearchKey,
    searchKey,
    setLimit,
    limit,
    currentPage,
    setCurrentPage,
    nextId,
    handlePageChange,
    handlePageSize,
    handleStatus,
    openStatus,
    setOpenStatus,
    handleDeactiveUser,
    userResignCount,
    loading2,
    hasMore,
    setSelectedAssistant,

    setIsListModelOpen,
    isListModelOpen,
    setSelectedMeeting,
    selectedMeeting,
    presonList,
    selectedAssistant,
    setIsListModelOpen,
   
    
    
    selectedId,
    setSelectedId,
    handleReassign,
    loader
    
   
    

  };
};

export default useEvents;